/** @format */

import { get } from "./BaseApi";
import endpoint from "./endpoint";

export const getInfoUser = async (userToken) => {
    try {
        return await get(
            endpoint.URL_GET_INFO,
            {
                user_token: userToken,
            }
        );
    } catch (err) {
        console.log(err);
    }
};
